// src/pages/touchPoints/timeline/dims.js
// Single source of truth for rendered heights + the universal buffer, so the
// layout (card positions) and the canvas (journey panels) compute identical
// geometry. Values are the measured rendered heights of the node components.

// Stable per-journey hue (keyed off journey_id so a journey is the same color in
// the list and the workflow). Matches the .tl-hue-N header colors in timeline.css.
export const HUES = ['#3b6ea5', '#3f8f5b', '#7a5aa8', '#c07a2e', '#3f8f8f'];
export const hueIndexOf = (journeyId) => ((journeyId % HUES.length) + HUES.length) % HUES.length;
export const hueOf = (journeyId) => HUES[hueIndexOf(journeyId)];
// mix a hex color toward white by `amt` (0..1) → an opaque muted shade
export const lighten = (hex, amt) => {
  const n = parseInt(hex.slice(1), 16);
  const m = (c) => Math.round(c + (255 - c) * amt);
  return `rgb(${m((n >> 16) & 255)},${m((n >> 8) & 255)},${m(n & 255)})`;
};
// a hex color at alpha `a` (0..1) → rgba() string (browser-safe; avoids CSS color-mix)
export const rgbaOf = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

export const PAD = 16;            // universal breathing room around cards and headers
export const HEADER_HEIGHT = 101; // journey header (eyebrow + name) + one-row segment bar
export const CARD_FULL = 197;     // touchpoint card, metrics on (wait line + 2-line clamped message)
export const CARD_COLLAPSED = 93; // touchpoint card, metrics off (2-line clamped message)

// First-paint estimate only. Chips wrap (see .tl-chips), so a bar with long clauses can
// be taller than one row; TimelineCanvas measures each panel's actual segment-bar bottom
// after paint and re-lays out, so this constant just seeds the layout before measurement.
export function headerHeight() {
  return HEADER_HEIGHT;
}
